import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../service/user.service';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
// models
import {ApiUserService} from '../../service/api-user.service';
import {PopupsComponent} from '../popups/popups.component';
import {MessagingService} from '../../service/messaging.service';

@Component({
  selector: 'app-create-api-key',
  templateUrl: './create-api-key.component.html',
  styleUrls: ['./create-api-key.component.scss']
})
export class CreateApiKeyComponent implements OnInit, OnDestroy {
  private apiUser;
  public generateApiKeyForm: FormGroup;
  public origins;
  public updateUser;
  public atLeastOneSelected = false;
  public formSubmitted = false;
  public retrievingData = true;
  public updatableUser;
  public titleObserver;
  public modalTitle;
  public allSelect = false;
  public currentRoute;
  public currentUser;
  public searchTerm;

  constructor(private userService: UserService,
              private apiUserService: ApiUserService,
              public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              public msgService: MessagingService) {
  }

  ngOnInit(): void {

    // live observables
    this.userService.currentUserSubject
      .subscribe((user) => {
        this.currentUser = user;
      });

    this.apiUserService.routerSubject
      .subscribe((val) => {
        this.currentRoute = val;
      });

    this.titleObserver = this.msgService.modalTitleSubject
      .subscribe((result) => {
        this.modalTitle = result;
      });

    this.origins = this.apiUserService.contentOrigins;

    this.userService.updatedUserSubject
      .subscribe((user) => {
        this.updatableUser = user;
      });

    this.userService.updatedUserSubject
      .subscribe((result) => {
        this.updateUser = result;
        if (this.updateUser === null || this.updateUser === undefined) {
          this.updateUser = {
            name: null,
            email: null,
            content_origin: null,
            contracts: null,
            notifications: null
          };
        }
      });

    // FORM
    this.generateApiKeyForm = new FormGroup({
      'name': new FormControl(this.updateUser.name, Validators.required),
      'email': new FormControl(this.updateUser.email, [Validators.required, Validators.email]),
      'content_origin': new FormControl(this.updateUser.content_origin),
      'contracts': new FormArray([]),
      'notifications': new FormControl(this.checkIfExists(this.updateUser.notifications))
    });

    this.apiUserService.getContracts(this.updatableUser)
      .subscribe((result) => {
        result.forEach(obj => {
          const control = new FormControl(obj, Validators.required);
          (<FormArray>this.generateApiKeyForm.get('contracts')).push(control);
          if (this.updateUser.contracts !== null && this.updateUser.contracts !== undefined) {
            for (let i = 0; this.generateApiKeyForm.get('contracts').value.length > i; i += 1) {
              delete (<FormArray>this.generateApiKeyForm.get('contracts')).value[i].checked;
              for (let x = 0; this.updatableUser.contracts.length > x; x += 1) {
                if (this.updatableUser.contracts[x].id === this.generateApiKeyForm.get('contracts').value[i].id) {
                  (<FormArray>this.generateApiKeyForm.get('contracts')).value[i].checked = true;
                }
              }
            }

          } else {
            for (let i = 0; this.generateApiKeyForm.get('contracts').value.length > i; i += 1) {
              delete (<FormArray>this.generateApiKeyForm.get('contracts')).value[i].checked;
            }
          }
          this.retrievingData = false;
        });
        if (this.updateUser.contracts !== null && this.updateUser.contracts !== undefined) {
          if ((this.updateUser.contracts.length === (<FormArray>this.generateApiKeyForm.get('contracts')).length)) {
            this.allSelect = true;
          }
        }
      });


  }

  ngOnDestroy() {
  }

  checkIfExists(val) {
    if (val) {
      return true;
    } else {
      return false;
    }
  }

  search(val: any) {
    this.searchTerm = val.target.value;
  }

  onSelectAll(event) {
    if (this.allSelect === false) {
      this.generateApiKeyForm.get('contracts').value.forEach((obj) => {
        obj.checked = true;
      });
      this.allSelect = true;
    } else {
      this.generateApiKeyForm.get('contracts').value.forEach((obj) => {
        delete obj['checked'];
      });
      this.allSelect = false;
    }
  }

  onCheckContract(e) {
    var counter = -1;
    this.generateApiKeyForm.get('contracts').value.forEach((obj) => {
      counter +=1;
      if(obj.id == e.target.value){
        obj.checked = e.target.checked;
      }
    });

    this.formSubmitted = false;
  }

  updateDisableField() {

    if (Object.keys(this.updateUser).length !== 0 && this.updateUser.name && this.updateUser.name !== null) {
      return true;
    } else {
      return false;
    }
  }

  onCheckNotification(e) {
    console.log(this.generateApiKeyForm.value);
  }

  onSubmit() {
    const form = this.generateApiKeyForm;
    this.formSubmitted = true;
    let contractArray = (<FormArray>this.generateApiKeyForm.get('contracts'));

    contractArray = contractArray.value.filter(function (elem, index, array) {
      if (contractArray.value[index].checked)
        return contractArray.value[index].checked === true;
    });

    if (contractArray.length === 0) {
      this.atLeastOneSelected = false;
    } else {
      this.atLeastOneSelected = true;
    }

    this.apiUser = {
      name: form.value.name,
      email: form.value.email,
      content_origin: form.value.content_origin,
      contracts: contractArray,
      notifications: form.value.notifications
    };

    // create
    if (this.updatableUser === undefined || this.currentRoute.aka === 'org') {
      if (this.currentRoute.aka === 'org') {
        this.apiUser.organization_id = this.updatableUser.id;
      }
      if (this.currentRoute.aka === 'orguser') {
        this.apiUser.organization_id = this.currentRoute.route.substr(this.currentRoute.route.lastIndexOf('/') + 1);
      }
      this.apiUserService.createUserApiKey(this.apiUser)
        .subscribe((result) => {
          let modalRef;
          this.activeModal.dismiss('Closed on successful submit');
          this.userService.setPopupObject(result);
          modalRef = this.modalService.open(PopupsComponent);
        }, err => {
          this.formSubmitted = false;
        });

    } else {
      this.apiUserService.updateApiUser(this.apiUser, this.updatableUser.id)
        .subscribe((result) => {
          Object.assign(this.updatableUser, result);
          this.activeModal.dismiss('Closed on successful submit');
        }, err => {
          this.formSubmitted = false;
        })
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/modal-edit/create-api-key/create-api-key.component.ts